module.exports = __webpack_public_path__ + "img/6-twoImg.9898c1a8.png";